// extracted by mini-css-extract-plugin
module.exports = {"osaAnalyse":"osaAnalyse___24Op3","search":"search___3Kjgt"};